<script setup>
import {reactive, onMounted, onUnmounted} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'AgeInfoComponent';

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  loadingClient: false,
  editDateReceived: false,
  menu1: null,
  date: null,
  contextSchema: null,
  search: '',
  changingClient: false,
  claims: false,
  selectedClient: null,
  clients: [],
  clientNames: [],
  clientId: null,
  loaded: true,
  name: '',
  phone: '',
  datetypeview: 'dates',
  now: new Date(),
  dates: []
});

const formatDate = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

const saveDateReceived = async() => {
  data.loadingClient = true
  await ApiWrapper.post('claims','save-appointment-date', {
    claimId: props.contextIdA,
    date: data.datereceived
  })
  .then((response) => {
    getData();
    activeComponentStore.notifyComponents(['claimstatusupdate'],compName);

    ToastUtil.successMsg('Updated appointment date');
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loadingClient = false;
  })
}

const save = () => {
  data.loadingClient = true
  ApiWrapper.post('claims','save-appointment-date', {
    claimId: props.contextIdA,
    date: data.date
  })
  .then((response) => {
    getData()
    activeComponentStore.notifyComponents(['claimstatusupdate'],compName);
    ToastUtil.successMsg('Updated appointment date');
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loadingClient = false;
  })
}

const getData = async() => {
  data.loadingClient = true

  await ApiWrapper.post('claims','load-age-info', {
    claimId: props.contextIdA
  })
  .then((response) => {
    if(response.info){
      data.dates = response.info;
    }

    data.loadingClient = false;
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loadingClient = false;
  })
}

onMounted(()=>{

  activeComponentStore.registerComponent(
      compName,
      [
          'tasks',
          'claims',
          'appointments'
      ],
      getData
  );

  data.contextSchema = props.contextSchemaA;
  getData()
})

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

</script>

<template>
  <v-container fluid class="pa-5">
      <v-card class="mx-auto">
        <v-toolbar density="compact" flat color="white">
          <v-toolbar-title>Progress Info</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>

        <v-row v-if="data.editDateReceived" class="px-5">
          <!--
          TODO: Fix this
          <v-menu
              ref="menu1"
              v-model="data.menu1"
              :close-on-content-click="true"
              transition="scale-transition"
              :return-value="data.datereceived"
              bottom
              :offset-y="data.offset1"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.datereceived"
                  label="Appointment Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @input="$refs.menu1.save(formatDate(data.date))"
            ></v-date-picker>
          </v-menu>
          -->
          <v-btn
              size="x-small"
              variant="elevated"
              color="primary"
              @click="data.editDateReceived = false; save()"
          >
            <v-icon> mdi-plus </v-icon>
          </v-btn>

          <v-btn
              size="x-small"
              variant="elevated"
              color="error"
              @click="data.editDateReceived = false"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
          <v-date-picker
          v-model="data.date"
          scrollable
          style="height: 50%"
          >

          </v-date-picker>
<!--          <v-menu-->
<!--              ref="menu1"-->
<!--              v-model="data.menu1"-->
<!--              :close-on-content-click="true"-->
<!--              transition="scale-transition"-->
<!--              :return-value="data.datereceived"-->
<!--              bottom-->
<!--              :offset-y="data.offset1"-->
<!--              max-width="290px"-->
<!--              min-width="auto"-->
<!--          >-->
<!--            <template v-slot:activator="{ on, props }">-->
<!--              <v-text-field-->
<!--                  v-model="data.datereceived"-->
<!--                  label="Appointment Date"-->
<!--                  v-bind="props"-->
<!--                  v-on="on"-->
<!--                  clearable-->
<!--                  readonly-->
<!--                  prepend-inner-icon="mdi-calendar"-->
<!--              ></v-text-field>-->
<!--            </template>-->
<!--            <v-date-picker-->
<!--                v-model="data.date"-->
<!--                no-title-->
<!--                :show-current="true"-->
<!--                @input="$refs.menu1.save(formatDate(data.date))"-->
<!--            ></v-date-picker>-->
<!--          </v-menu>-->



        </v-row>


        <div v-if="!data.changingClient && !data.loadingClient">
          <v-list subheader>

            <template v-for="(item) in data.dates" :key="item">
              <v-list-item density="compact">
                <v-list-item-title class="py-0">{{item.name}}</v-list-item-title>
                <v-list-item-action v-if="item.datestamp">

                    <!-- <v-list-item-title v-if="datetypeview =='dates' || index < 2">{{item.date.toLocaleDateString()}}
                    </v-list-item-title>
                    <v-list-item-title v-if="index > 1 && datetypeview =='progress'">
                      {{Math.round((item.date.getTime()-dates[index-1].date.getTime())/86400000)}} Days
                    </v-list-item-title>
                    <v-list-item-title v-if="index > 1 && datetypeview =='dayssince'">
                      {{Math.round((item.date.getTime()-dates[1].date.getTime())/86400000)}} Days
                    </v-list-item-title> -->
                    <v-list-item-title v-if="data.datetypeview === 'dates'">
                      {{item.datestamp}}
                    </v-list-item-title>
<!--                    <v-btn-->
<!--                        size="x-small"-->
<!--                        variant="elevated"-->
<!--                        class="ml-3"-->
<!--                        color="primary"-->
<!--                        v-if="item.name === 'Appointment Date' && Permissions.checkPermissions(['appointments.save-date'])"-->
<!--                        @click="data.editDateReceived = true; data.datereceived = item.datestamp;"-->
<!--                    >-->
<!--                      <v-icon> mdi-pencil </v-icon>-->
<!--                    </v-btn>-->
                </v-list-item-action>
                <v-list-item-title v-else>Not Completed</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
          <div class="text-center mb-5">
            <v-btn-toggle v-model="data.datetypeview" tile group color="primary">
              <v-btn value="dates" size="x-small" variant="elevated">
                Dates
              </v-btn>
              <!-- <v-btn value="progress" x-small>
                Progress
              </v-btn>
              <v-btn value="dayssince" x-small>
                Days Since
              </v-btn> -->
            </v-btn-toggle>
          </div>

        </div>
      </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }
  
  [v-cloak] {
    display: none;
  }
  
  .v_list_search {
    height: 200px;
    overflow-y: auto;
  }

  .v-list-item-title {
    font-size: 13px !important;
    color: black !important;
  }
  .v-list-item-subtitle {
    font-size: 10px !important;
    color: black !important;
  }
</style>